<template>
  <header :style="{ 'padding-right': headerRightMargin }">
    <div class="top-row">
      <div @click="goHome" class="title pointer">
        <template v-if="!hideRijnjaContent">
          <h1>Signing</h1>
          <h2>Prints voor professionals</h2>
        </template>
      </div>
      <section class="search-cell">
        <search-menu></search-menu>
      </section>
      <section class="search-bar">
        <div class="search-cart-holder">
          <search-bar></search-bar>
          <!--           <button class="cart" @click="startCheckout">

            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="22"
              height="18"
              viewBox="0 0 22 18"
              :class="['ico-cart', { added: addToBasket }]"
              src="@/images/cart.svg"
            >
              <g fill="none" fill-rule="evenodd" transform="translate(1 1)">
                <polyline
                  stroke="#002169"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  points="19.565 0 16.957 0 14.348 10.435 1.304 10.435 0 3.913"
                />
                <circle cx="3.304" cy="14.739" r="2" fill="#002169" />
                <circle cx="13.087" cy="14.739" r="2" fill="#002169" />
              </g>
            </svg>
          </button>
 -->
        </div>
      </section>

      <section class="cart-cell">
        <button class="cart" @click="startCheckout">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="22"
            height="18"
            viewBox="0 0 22 18"
            :class="['ico-cart', { added: addToBasket }]"
            src="@/images/cart.svg"
          >
            <g fill="none" fill-rule="evenodd" transform="translate(1 1)">
              <polyline
                stroke="#002169"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                points="19.565 0 16.957 0 14.348 10.435 1.304 10.435 0 3.913"
              />
              <circle cx="3.304" cy="14.739" r="2" fill="#002169" />
              <circle cx="13.087" cy="14.739" r="2" fill="#002169" />
            </g>
          </svg>
        </button>
      </section>
    </div>
  </header>
</template>
<script>
import { mapStores } from 'pinia'
import { usePrintStoreStore } from '@/features/printstore/PrintStore.store'
import SearchBar from '../search/SearchBar.vue'
import SearchMenu from '@/features/printstore/children/search/SearchMenu.vue'
import InteractionMixin from '@/mixins/InteractionMixin'
import PrintStoreMixin from '../../PrintStoreMixin'

export default {
  props: {
    addToBasket: {
      default: false
    }
  },
  data() {
    return {
      //logoPlaceholder: {}
      headerRightMargin: ''
    }
  },
  mixins: [InteractionMixin, PrintStoreMixin],
  components: { SearchBar, SearchMenu },
  mounted() {
    if (this.rootStore.theme.header.menuRight.customLogo) {
      const elem = document.getElementById('app-logo')
      if (elem) {
        const rect = elem.getBoundingClientRect()

        this.headerRightMargin = Math.round(rect.width) + 'px'
      }
    } else {
      this.headerRightMargin = '190px'
    }
  },
  computed: {
    ...mapStores(usePrintStoreStore),
    basketColor() {
      return {
        fill:
          this.printStoreStore.orderDetails.cart.length > 0
            ? 'var(--sub-color)'
            : '#bbb'
      }
    }
  },
  methods: {
    goHome() {
      this.$router.push({ name: 'printStore' })
    }
    /*     startCheckout() {

      this.printStoreStore.routeBeforeCheckout(this.$router.currentRoute)
      const printOrder = this.rootStore.interactions.find(
        (ia) => ia.destination === 'printOrder'
      )
      this.startInteraction(printOrder)
    } */
  }
}
</script>

<style lang="scss" scoped>
header {
  margin: 20px 0 20px 58px;
}
.top-row {
  display: flex;
  align-items: center;
}

.title {
  flex-grow: 1;
  h1 {
    font-size: 24px;
    color: var(--sub-color);
    margin-bottom: 4px;
    font-weight: 400;
  }
  h2 {
    color: var(--sub-color);
  }
}

.cart-cell {
  flex-grow: 0;
  flex-shrink: 0;
  padding-left: 14px;
  padding-right: 20px;

  /*   svg {
    height: auto;
    width: 21px;
  } */

  /*  .sub-color {
    fill: var(--sub-color);
  } */
}

.search-cart-holder {
  width: 295px;
  margin: 0 auto;

  .cart {
    padding-left: 10px;
  }
}

.search-cell {
  position: relative;
}

.search-bar {
  display: none;
}

.divider {
  margin: 0 5px;
  width: 10px;
}

.added {
  animation: basket 0.5s;
}

/* .logo-ph {
  display: none;
} */

.cart {
  font-size: 12px;
  color: var(--sub-color);
  font-weight: 500;

  span {
    display: none;
  }
}

.ico-cart {
  vertical-align: bottom;
  margin-left: 5px;
  polyline {
    stroke: var(--sub-color);
  }

  g circle {
    fill: var(--sub-color);
  }
}

@keyframes basket {
  0% {
    transform: scale(1);
  }

  50% {
    transform: scale(1.5);
  }

  100% {
    transform: scale(1);
  }
}

@media only screen and (min-width: 768px) {
  header {
    margin: 21px 0 20px 177px;
  }
}

@media only screen and (min-width: 940px) {
  header {
    margin: 0;
    padding: 37px 0 15px 0;
    width: 100%;
    //width: calc(100% - 200px);
  }
  .top-row {
    padding-right: 15px;
  }

  /* .logo-ph {
    display: block;
    flex-grow: 0;
    flex-shrink: 0;
    flex-basis: 200px;
  } */

  .search-cell {
    flex-grow: 1;
    text-align: right;
  }

  .title {
    flex-grow: 0;
    padding-right: 15px;
  }

  .cart span {
    display: inline-block;
  }
  /* 
  .cart-cell {
    padding-top: 9px;
  } */
}
@media only screen and (min-width: 1024px) {
  .search-bar {
    display: inline-block;
    flex-grow: 1;
    margin: 0 auto;
  }

  .cart-cell {
    display: none;
  }

  .search-cell {
    display: none;
    width: 0;
    flex-grow: 0;
  }
  .title {
    flex-shrink: 0;
    h1 {
      //    font-size: 30px;
    }
  }
}
@media only screen and (min-width: 1200px) {
  .search-cell {
  }

  .search-bar {
  }

  .cart-cell {
    flex-grow: 0;
    padding-right: 25px;
  }
}
</style>
